import dateFormat from 'dateformat'
import config from './config'
import { randomString, generateSign, deviceId, cookie } from './utils'

const httpRequest = (apiUrl: string, _params? :object) => {
  let lang = cookie.getCookie('LANG_MODE')
  if (!lang || lang === 'zh') {
    lang = 'zh-CN'
  }
  let usrDeviceId = cookie.getCookie('device_id')
  if (!usrDeviceId) {
    usrDeviceId = deviceId()
    cookie.autoCookie('device_id', usrDeviceId)
  }
  let commonObj = {
    appKey: config.appKey,
    HTTP_API_VERSION: '4.1',
    reqId: randomString(16),
    timeStamp: dateFormat((new Date()), 'yyyymmddHHMMss'),
    device_id: usrDeviceId,
    lang: lang
  }

  let userObj = {
    device_id: usrDeviceId,
    user_id: cookie.getCookie('user_id'),
    verify: cookie.getCookie('verify')
  }

  let sign = ''
  let obj
  if (userObj.device_id && userObj.user_id && userObj.verify) {
    obj = { ...commonObj, ...userObj, ..._params }
    sign = generateSign(obj)
  } else {
    obj = { ...commonObj, ..._params }
    sign = generateSign(obj)
  }
  obj = { ...obj, sign: sign }

  return $.ajax({
    dataType: 'jsonp',
    cache: true,
    url: config.apiDomain + apiUrl,
    data: obj
  })
}

export default httpRequest
